const GlobalFilters = {
  MaxListSelectable: 10,
  InvalidDate: 'Invalid date',
};

export default GlobalFilters;
